const API_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
const APP_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;

/* News feed base url */
const NEWS_API_BASE_URL = process.env.NEXT_PUBLIC_NEWS_API_BASE_URL;

/*Probo widget base url */
const PROBO_API_URL = process.env.NEXT_PUBLIC_PROBO_API_BASE_URL;

const PROBO_LIVE_API_URL = process.env.NEXT_PUBLIC_PROBO_LIVE_API_BASE_URL;

/* Static Contents url */
const CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;

/* movie list api routes */
const MOVIE_LIST = `${API_URL}/movies`;

/* slug api for movie-id */
const SLUG_API = `${API_URL}/wiki`;

/* box office collection api routes */
const BOX_OFFICE_COLLECTION_MOVIE_LIST = `${API_URL}/movies/box_office_collections`;

/* vahan page api call */

const VAHAN_EDIT = `${API_URL}/entity/vahan`;

const VAHAN_METRICS = `${API_URL}/metrics/vahan`;

/**News feed page*/
const NEWS_PAGE = `${NEWS_API_BASE_URL}/news/feed`;

/**Entity feed page*/
const ENTITY_PAGE = `${API_URL}/entity`;

/**Detail Page api*/
const DETAIL_PAGE = `${NEWS_API_BASE_URL}/news/details`;

/**User engagement*/
const NEWS_USER_ENGAGEMENT = `${NEWS_API_BASE_URL}/news`;

/**Category api feed page */
const CATEGORY_PAGE = `${NEWS_API_BASE_URL}/news/categories`;

const NEWS_SSO_LOGIN_PAGE = `${NEWS_API_BASE_URL}/auth/sso`;

const NEWS_AUTH_URL = `${NEWS_API_BASE_URL}/auth`;

/**Upi and netc api */
const UPI_EDIT = `${API_URL}/entity/upi`;
const UPI_METRICS = `${API_URL}/metrics/upi`;
const NETC_EDIT = `${API_URL}/entity/netc`;

/** Youtube api */
const YOUTUBE_EDIT = `${API_URL}/metrics/youtube_v1`;
/** Weather API  */
const WEATHER_UNION = `${API_URL}/metrics/weatherunion`;
/** Youtube api */
// const YOUTUBE_EDIT=`${API_URL}/metrics/youtube`

/**Trading event probo widget*/
const PROBO_TRADING_EVENT = `${PROBO_API_URL}/tms/trade/public/eventGraphData`;

/**Probo product event */
const PROBO_PRODUCT_EVENT = `${PROBO_API_URL}/product/public/events`;

/**Entity user session api*/
const ENTITY_USER_SESSIONS = `${NEWS_API_BASE_URL}/sessions/ping`;


const CRICKET_WIDGET = `${API_URL}/widget`;
const ENTITY_DATA = `${API_URL}/entity`;

const ADVERTISEMENT_BANNER = `${PROBO_LIVE_API_URL}/api/v1/banner`;

const SERIES_STATIC_ASSETS = `${CDN_URL}/datamuni_product_images/sport/cricket/series`;

const MATCH_DETAILS_AND_WIDGETS = `${ENTITY_DATA}/sport/cricket/matches`;

export {
    APP_URL,
    MOVIE_LIST,
    SLUG_API,
    BOX_OFFICE_COLLECTION_MOVIE_LIST,
    NEWS_API_BASE_URL,
    VAHAN_EDIT,
    VAHAN_METRICS,
    NEWS_PAGE,
    CATEGORY_PAGE,
    DETAIL_PAGE,
    UPI_EDIT,
    UPI_METRICS,
    NETC_EDIT,
    NEWS_SSO_LOGIN_PAGE,
    NEWS_USER_ENGAGEMENT,
    YOUTUBE_EDIT,
    NEWS_AUTH_URL,
    PROBO_TRADING_EVENT as TRADING_EVENT,
    PROBO_PRODUCT_EVENT,
    WEATHER_UNION,
    CRICKET_WIDGET,
    ENTITY_PAGE,
    ADVERTISEMENT_BANNER,
    SERIES_STATIC_ASSETS,
    MATCH_DETAILS_AND_WIDGETS,
    ENTITY_USER_SESSIONS,
};
